import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-messages-report',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './messages-report.component.html',
})
export class MessagesReportComponent {}
